import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { autoUpdate, offset, shift, useFloating, useFocus, useHover, useInteractions } from '@floating-ui/react';
import { useIsomorphicLayoutEffect } from '@react-hookz/web';
import { Children, useState } from 'react';
import { useDispatch } from 'react-redux';
import { MainNavigationClicked } from '../../../../components/HeaderNew/actionTypes.js';
import { LinkItem } from '../../../../components/Menu/components/LinkItem.js';
import { Container } from '../../../../components/Menu/components/MenuItem/components/Container.js';
import { Title } from '../../../../components/Menu/components/MenuItem/components/Title.js';
import { SubMenuArea } from '../../../../components/Menu/components/SubMenuArea.js';
import { Fade } from '../../../../primitives/Transition/index.js';
import { UnstyledButton } from '../../../../primitives/UnstyledButton/index.js';
import { HEADER_QA_ID, qaId } from '../../../../utils/qaId.js';
export const MenuItem = ({
  label,
  id,
  children,
  link,
  align,
  stretchTexts
}) => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const {
    refs,
    context,
    update,
    floatingStyles
  } = useFloating({
    open,
    onOpenChange: setOpen,
    middleware: [offset({
      mainAxis: 8,
      crossAxis: -64
    }), shift({
      padding: 12
    })],
    placement: 'bottom-start',
    strategy: 'fixed',
    whileElementsMounted: autoUpdate
  });
  const {
    getReferenceProps,
    getFloatingProps
  } = useInteractions([useHover(context), useFocus(context)]);
  useIsomorphicLayoutEffect(() => {
    if (open) {
      update();
    }
  }, [open, update]);
  const handleClick = () => {
    dispatch({
      type: MainNavigationClicked,
      payload: {
        text: label
      }
    });
  };
  const title = _jsx(Title, {
    onClick: handleClick,
    children: link ? _jsx(LinkItem, {
      url: link.path,
      masked: link.masked,
      target: link.target,
      children: label
    }) : _jsx(UnstyledButton, {
      children: label
    })
  });
  const subItems = Children.toArray(children);
  return _jsxs(Container, {
    ref: refs.setReference,
    "data-cy": qaId(HEADER_QA_ID, 'menuItem', id),
    "data-testid": qaId(HEADER_QA_ID, 'menuItem', id),
    "data-label": label,
    align: align,
    stretchTexts: stretchTexts,
    ...getReferenceProps(),
    children: [title, subItems.length > 0 && _jsx(Fade, {
      in: open,
      duration: 150,
      mountOnEnter: false,
      unmountOnExit: false,
      children: _jsx(SubMenuArea, {
        ref: refs.setFloating,
        style: floatingStyles,
        "data-cy": qaId(HEADER_QA_ID, 'menuLinks', id),
        "data-testid": qaId(HEADER_QA_ID, 'menuLinks', id),
        ...getFloatingProps(),
        children: children
      })
    })]
  });
};